import { ActionTypes } from "../constants";

export default function userState(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_USER_ESIGN_STATE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}